import template from './template.html';

config.$inject = ['$stateProvider'];

function config($stateProvider) {
    $stateProvider.state('guest', {
        abstract: true,
        template: template,
        url: '/'
    });
}

export default config;



// WEBPACK FOOTER //
// ./src/js/components/guest/_guest/index.js